module.exports = __webpack_public_path__ + "static/media/3k_website_logo_coorg_ogcio.3438f860.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/3k_website_logo_coorg_ogcio.jpg
// module id = 51
// module chunks = 0